import axios from "axios/index";
import { API } from "../utilities/api.config";

function saveUserBdRepCode(userBdRepCode) {
  return (dispatch) => {
    dispatch({
      type: "USER_BD_REP_CODE_UPDATE_REQUESTED",
    });
    axios
      .post(`${API.REP_CODE}/updateBrokerDealerRepCode`, userBdRepCode, {
        headers: { Authorization: `${localStorage.getItem("wbiAuthToken")}` },
      })
      .then((response) => {
        dispatch({
          type: "USER_BD_REP_CODE_UPDATE_SUCCESS",
          payload: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "USER_BD_REP_CODE_UPDATE_FAIL",
          payload: error,
        });
      });
  };
}

function deleteSplitRepCode(userBdRepCode) {
  return (dispatch) => {
    dispatch({
      type: "REP_CODE_UPDATE_REQUESTED",
    });
    axios
      .post(`${API.REP_CODE}/deleteBrokerDealerRepCode`, userBdRepCode, {
        headers: { Authorization: `${localStorage.getItem("wbiAuthToken")}` },
      })
      .then((response) => {
        dispatch({
          type: "REP_CODE_UPDATE_SUCCESS",
          payload: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "REP_CODE_UPDATE_FAIL",
          payload: error,
        });
      });
  };
}

function requestPasRepCode(data) {
  return (dispatch) => {
    dispatch({
      type: "USER_BD_REP_CODE_UPDATE_REQUESTED",
    });
    axios
      .post(`${API.REP_CODE}/requestPasRepCode`, data, {
        headers: { Authorization: `${localStorage.getItem("wbiAuthToken")}` },
      })
      .then((response) => {
        dispatch({
          type: "USER_BD_REP_CODE_UPDATE_SUCCESS",
          payload: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "USER_BD_REP_CODE_UPDATE_FAIL",
          payload: error,
        });
      });
  };
}

function updateInProcessShown(data) {
  return (dispatch) => {
    dispatch({
      type: "USER_BD_REP_CODE_UPDATE_REQUESTED",
    });
    axios
      .post(`${API.REP_CODE}/updateInProcessShown`, data, {
        headers: { Authorization: `${localStorage.getItem("wbiAuthToken")}` },
      })
      .then((response) => {
        dispatch({
          type: "USER_BD_REP_CODE_UPDATE_SUCCESS",
          payload: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "USER_BD_REP_CODE_UPDATE_FAIL",
          payload: error,
        });
      });
  };
}

export const repCodeAction = {
  saveUserBdRepCode,
  requestPasRepCode,
  deleteSplitRepCode,
  updateInProcessShown,
};

export default repCodeAction;



// WEBPACK FOOTER //
// ./src/actions/repcode.action.js